define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var core = require('core');
    var config = require('config');
    var Class = require('Class');
    var Backbone = require('backbone');

    var USE_OLD_PARSER = true;

    /*
    // Data mocks as examples

    var dataLayouts = [
        {
            name: 'Layout_1',
            top: [
                '1  1  2  3',
                '1  1  4  3',
                '6  7  8  9',
                '10 10 11 12',
                '10 10 13 14',
                '15 16 17 17'
            ],
            left: [
                '1  1  2 ',
                '1  1  3 ',
                '4  5  6 ',
                '7  7  8 ',
                '7  7  9 ',
                '10 11 12'
            ]
        }
    ];

    var dataLayoutsOld = [
        {
            name: 'Layout_1',
            top: [
                [[1, 1], [1, 2], [2, 1], [2, 2]],
                [[1, 3]],
                [[1, 4]],
                [[2, 3]],
                [[2, 4]],
                [[3, 1]],
                [[3, 2]],
                [[3, 3]],
                [[3, 4]],
                [[4, 1], [4, 2], [5, 1], [5, 2]],
                [[4, 3]],
                [[4, 4]],
                [[5, 3]],
                [[5, 4]],
                [[6, 1]],
                [[6, 2]],
                [[6, 3]],
                [[6, 4]]
            ],
            left: [
                [[1, 1], [1, 2], [2, 1], [2, 2]],
                [[1, 3]],
                [[1, 4]],
                [[2, 3]],
                [[3, 1]],
                [[3, 2]],
                [[3, 3]],
                [[4, 1], [4, 2], [5, 1], [5, 2]],
                [[4, 3]],
                [[5, 3]],
                [[6, 1]],
                [[6, 2]],
                [[6, 3]]
            ]
        }
    ];
    */

    var LayoutHelper = Class.create(Backbone.Events, {

        DEFAULT_1X1_TOKEN: '__$1X1',

        initialize: function() {
            this.listenTo(core, 'app:initialResourcesLoaded', this._parseSourceLayouts.bind(this));
        },

        /**
         * Gets layout by current params from parsed layouts
         * @param {String} layoutName
         * @param {Object} options
         * @param {String} options.navigationPosition
         * @param {String} options.navigationStyle
         * @return {Object|null}
         */
        getMap: function(layoutName, options) {
            this._parseSourceLayouts();
            if (!this._layouts) {
                return null;
            }

            if (layoutName === this.DEFAULT_1X1_TOKEN) {
                return null;
            }
            var layout = layoutName && this._layouts[layoutName];
            var layoutType = options && options.navigationPosition === 'LEFT' && options.navigationStyle === 'MENU'
                ? 'left'
                : 'top';
            return layout && layout[layoutType];
        },

        _parseSourceLayouts: function() {
            var layouts = config.get('gamesTilesLayouts.layouts');

            if (!layouts) {
                this._layouts = null;
                return;
            }

            this._layouts = _.chain(layouts)
                .groupBy('name')
                .mapObject(0)
                .mapObject(this._parseLayout.bind(this))
                .value();
        },

        _parseLayout: function(layout) {
            return _.extend({}, layout, this._prepareGrids(layout));
        },

        _prepareGrids: function(layout) {
            var parseSourceGrid = USE_OLD_PARSER ? this._parseOldSourceGrid : this._parseSourceGrid;

            return _.chain(layout)
                .pick(['left', 'top'])
                .mapObject(parseSourceGrid)
                .mapObject(this._mapGridProperties)
                .each(this._validateParsedGrid)
                .value();
        },

        _parseSourceGrid: function(layout) {
            var i, j;

            var rows = layout.map(function(lt) {
                return lt.trim().split(/\s+/);
            });

            var result = {
                grid: {},
                gridHeight: rows.length,
                gridWidth: rows[0] && rows[0].length || 0
            };
            var grid = result.grid;

            for (j = 0; j < rows.length; j++) {
                var row = rows[j];
                for (i = 0; i < row.length; i++) {
                    var cell = row[i];

                    // find block in result or create new one
                    var block = grid[cell] = grid[cell] || {
                        x: Infinity,
                        xEnd: -1,
                        y: Infinity,
                        yEnd: -1
                    };

                    // assume lowest coordinate as block start and highest coordinate as block end
                    block.x = Math.min(block.x, i);
                    block.xEnd = Math.max(block.xEnd, i);
                    block.y = Math.min(block.y, j);
                    block.yEnd = Math.max(block.yEnd, j);
                }
            }

            return result;
        },

        /**
         * Parse data from this kind of format:
         * [[1, 1], [1, 2], [2, 1], [2, 2]],
         * [[1, 3]],
         * [[1, 4]],
         */
        _parseOldSourceGrid: function(data) {
            var preResult = data.reduce(function(tilesConf, tile, i) {
                var tilesArray = tilesConf.result;
                var conf, prevH, prevW;

                tile.forEach(function(tilePar) {
                    var tileRow, tileCol, tileX, tileY, row;

                    if (tilePar instanceof Array !== true) {
                        core.error('Tile ' + (i + 1) + ' should has next style [[' + tile + ']]');
                        return tilesConf;
                    }

                    tileRow = tilePar[0];
                    tileCol = tilePar[1];
                    tileX = tileCol - 1;
                    tileY = tileRow - 1;
                    row = tilesArray[tileY] = tilesArray[tileY] || [];

                    if (!conf) {
                        conf = {
                            h: 1,
                            w: 1,
                            x: tileX,
                            y: tileY,
                            yOrigin: tileY
                        };

                        tilesConf.map[tilesConf.tilesCount++] = conf;

                        prevH = tileRow;
                        prevW = tileCol;
                        row[tileX] = conf;
                    } else {
                        conf.h += tileRow - prevH;
                        conf.w += tileCol - prevW;
                        prevH = tileRow;
                        prevW = tileCol;

                        row[tileX] = null;
                    }
                });
                tilesConf.result = tilesArray;

                return tilesConf;
            }, {
                map: {},
                result: [],
                tilesCount: 0 // in layout
            });

            var result = {
                grid: _.mapObject(preResult.map, function(cell) {
                    return {
                        x: cell.x,
                        y: cell.y,
                        xEnd: cell.x + cell.w - 1,
                        yEnd: cell.y + cell.h - 1
                    };
                })
            };

            var gridWidth = 0;
            var gridHeight = 0;

            _.each(result.grid, function(cell) {
                if (cell.xEnd > gridWidth) {
                    gridWidth = cell.xEnd;
                }
                if (cell.yEnd > gridHeight) {
                    gridHeight = cell.yEnd;
                }
            });

            result.gridWidth = gridWidth + 1;
            result.gridHeight = gridHeight + 1;

            return result;
        },

        _mapGridProperties: function(layout) {
            var grid = layout.grid;
            var keys = Object.keys(grid);
            keys.forEach(function(key) {
                var block = grid[key];
                block.w = block.xEnd - block.x + 1;
                block.h = block.yEnd - block.y + 1;
            });

            layout.cellCount = keys.length;
            layout.list = _.map(grid);

            return layout;
        },

        _validateParsedGrid: function(layout) {
            var grid = layout.grid;
            var gridWidthMaxIdx = layout.gridWidth - 1;
            var gridHeightMaxIdx = layout.gridHeight - 1;
            var result = Object.keys(grid).every(function(key) {
                var block = grid[key];

                // check all coords are within grid dimensions
                if (block.x < 0 || block.x > gridWidthMaxIdx) {
                    return false;
                }
                if (block.y < 0 || block.y > gridHeightMaxIdx) {
                    return false;
                }
                if (block.xEnd < 0 || block.xEnd > gridWidthMaxIdx) {
                    return false;
                }
                if (block.yEnd < 0 || block.yEnd > gridHeightMaxIdx) {
                    return false;
                }

                // check starts vs ends
                if (block.x > block.xEnd) {
                    return false;
                }
                if (block.y > block.yEnd) {
                    return false;
                }

                return true;
            });

            if (!result) {
                core.warn('Layout is invalid', layout);
            }
        }

    });

    module.exports = new LayoutHelper();
});
